module.exports = __webpack_public_path__ + "h5/img/bargainBg.33fa7613.jpg";